import * as React from 'react';
import { SVGProps } from 'react';

const IconCodeSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2 4a3 3 0 0 1 3-3h1v2H5a1 1 0 0 0-1 1v1a3 3 0 0 1-1.2 2.4L2 8l.8.6A3 3 0 0 1 4 11v1a1 1 0 0 0 1 1h1v2H5a3 3 0 0 1-3-3v-1a1 1 0 0 0-.4-.8L0 9V7l1.6-1.2A1 1 0 0 0 2 5V4Zm9-1h-1V1h1a3 3 0 0 1 3 3v.5a2 2 0 0 0 .8 1.6L16 7v2l-1.2.9a2 2 0 0 0-.8 1.6v.5a3 3 0 0 1-3 3h-1v-2h1a1 1 0 0 0 1-1v-.5a4 4 0 0 1 1.6-3.2L14 8l-.4-.3A4 4 0 0 1 12 4.5V4a1 1 0 0 0-1-1Zm-.132 1.996-4 7-1.736-.992 4-7 1.736.992Z" />
  </svg>
);
export default IconCodeSizeM;
